import { IAmendmentAddEditRequest } from '../../../../model/sge/amendment/request/amendment-add-edit-request';
import { IParlamentarianPagedResponse } from '../../../../model/sge/parlamentarian/response/parlamentarian-paged-response';
import { IPoliticalPartyPagedResponse } from '../../../../model/sge/political-party/response/political-party-paged-response';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';
import { IBudgetActionResponse } from '../../../../model/sge/budget-action/response/budget-action-response';

export type AmendmentCreateEditState = {
    amendmentId?: string;
    amendmentRequest: IAmendmentAddEditRequest;
    parlamentarians: IParlamentarianPagedResponse[];
    politicalParties: IPoliticalPartyPagedResponse[];
    budgetUnits: IBudgetUnitResponse[];
    selectedBudgetUnitId?: number;
    budgetPrograms: IBudgetProgramResponse[];
    selectedBudgetProgramId?: number;
    budgetActions: IBudgetActionResponse[];
    files: File[];
    showValidationErrors: boolean;
};

export enum ACTION_TYPES {
    setAmendmentId = 'setAmendmentId',
    setAmendmentRequest = 'setAmendmentRequest',
    updateAmendmentRequest = 'updateAmendmentRequest',
    setParlamentarians = 'setParlamentarians',
    setPoliticalParties = 'setPoliticalParties',
    setBudgetUnits = 'setBudgetUnits',
    setSelectedBudgetUnitId = 'setSelectedBudgetUnitId',
    setBudgetPrograms = 'setBudgetPrograms',
    setSelectedBudgetProgramId = 'setSelectedBudgetProgramId',
    setBudgetActions = 'setBudgetActions',
    setFiles = 'setFiles',
    setShowValidationErrors = 'setShowValidationErrors',
}

export const AmendmentCreateEditReducer = (state: AmendmentCreateEditState, action: any): AmendmentCreateEditState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setAmendmentId:
            return { ...state, amendmentId: payload };
        case ACTION_TYPES.setAmendmentRequest:
            return { ...state, amendmentRequest: payload };
        case ACTION_TYPES.updateAmendmentRequest:
            return { ...state, amendmentRequest: { ...state.amendmentRequest, ...payload } };
        case ACTION_TYPES.setParlamentarians:
            return { ...state, parlamentarians: payload };
        case ACTION_TYPES.setPoliticalParties:
            return { ...state, politicalParties: payload };
        case ACTION_TYPES.setBudgetUnits:
            return { ...state, budgetUnits: payload };
        case ACTION_TYPES.setSelectedBudgetUnitId:
            return { ...state, selectedBudgetUnitId: payload };
        case ACTION_TYPES.setBudgetPrograms:
            return { ...state, budgetPrograms: payload };
        case ACTION_TYPES.setSelectedBudgetProgramId:
            return { ...state, selectedBudgetProgramId: payload };
        case ACTION_TYPES.setBudgetActions:
            return { ...state, budgetActions: payload };
        case ACTION_TYPES.setFiles:
            return { ...state, files: payload };
        case ACTION_TYPES.setShowValidationErrors:
            return { ...state, showValidationErrors: payload };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
